// Libs
import classNames from 'classnames/bind';
import { Avatar, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
import { getAvatarName, getFullName } from '~/utils/helper/common';
import { IBaseUser } from '~/utils/interface/common';
// Styles, images, icons
import styles from './BaseAvatar.module.scss';

type Props = {
  dataAccount: IBaseUser;
  size?: number;
  fontSize?: number;
};

const cx = classNames.bind(styles);

const BaseAvatar = (props: Props) => {
  //#region Destructuring Props
  const { dataAccount, size = 40, fontSize = 16 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='baseAvatarComponent'>
      {dataAccount?.avatarImage ? (
        <Avatar
          alt={t('common_alt_img')}
          sx={{ width: size, height: size }}
          src={dataAccount?.avatarImage}
          className={cx('avatar')}
        />
      ) : (
        <Avatar
          alt={t('common_alt_img')}
          sx={{ width: size, height: size }}
          className={cx('avatar')}
          style={{ fontSize }}
        >
          {getAvatarName(getFullName({ ...dataAccount }))}
        </Avatar>
      )}
    </Box>
  );
};

export default BaseAvatar;
